/* eslint-disable compat/compat */

const defaultConfig = {
  rootMargin: '0px 0px 0px 0px',
  threshold: [0, 0.5, 1]
}

export class ElementIntersectionObserver {
  intersections
  elements

  constructor(elements, onChange, config) {
    this.elements = elements.slice(0)
    this.intersections = elements.map(target => ({
      target,
      isIntersecting: false,
      ratio: null
    }))

    this.intersectionObserver = new IntersectionObserver(
      entries => {
        const intersections = this.intersections.slice(0)

        entries.forEach(entry => {
          const idx = elements.indexOf(entry.target)
          intersections.splice(idx, 1, {
            target: entry.target,
            isIntersecting: entry.isIntersecting,
            ratio: entry.intersectionRatio
          })
        })
        this.intersections = intersections
        onChange(this.intersections)
      },
      { ...defaultConfig, ...config }
    )

    elements.forEach(elm => this.intersectionObserver.observe(elm))
  }

  disconnect() {
    // Unregister trigger elements
    this.elements.forEach(elm => this.intersectionObserver.unobserve(elm))

    // Disconnect intersection observer
    this.intersectionObserver.disconnect()
  }
}
